import {
  ApiBlueprint,
  createFrontendModule,
  discoveryApiRef,
  fetchApiRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import ForumIcon from '@material-ui/icons/Forum';
import {
  GroupSlackChannelsClient,
  groupSlackChannelsApiRef,
} from './groupSlackChannelsApi';

const slackChannelsPage = PageBlueprint.make({
  name: 'slack-channels',
  params: {
    path: '/admin/slack-channels',
    title: 'Slack Channels',
    icon: <ForumIcon />,
    loader: () =>
      import('./SlackChannelsPage').then(m => <m.SlackChannelsPage />),
  },
});

const groupSlackChannelsApi = ApiBlueprint.make({
  name: 'group-slack-channels',
  params: define =>
    define({
      api: groupSlackChannelsApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new GroupSlackChannelsClient({ discoveryApi, fetchApi }),
    }),
});

export const slackChannelsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [slackChannelsPage, groupSlackChannelsApi],
});
